/*
yogeshsrigiri 09/29/2022 3075154998 implemented breadcrumbs for all the side menu
akhila        10/28/2022 3075154998 enable framework UX changes
Rohini       10/28/2022 3075154998 removed the classname cardstyling
ashraf 10/30/2022 3075154998 conditional tabs render
Rohini 10/31/2022 3075154998 added the classname for dashboard
*/
import {Card} from '@material-ui/core';
import React from 'react';
import Tabs from './Tabs';
import LandingPage from '../../LandingPage';

function EnableFramework() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const tabLabels = ['Filters', 'Filter Group', 'Media Type', 'Enable file format'];

  return (
    <>
      <LandingPage title={'Frameworks'} showTabs={true} tabValue={value} handleTabChange={handleChange} allAntTabs={tabLabels}>
      </LandingPage>
      <div className={`col-md-12 global-field-dash-board`}>
        <Card className={`mb-0`} elevation={0}>

          <Tabs value={value} setValue={setValue} />

        </Card>
      </div>
    </>
  );
}

export default EnableFramework;
